// Живая область тостов внутри слоя (FR-041б; components/Toast/README.md): окна, боковая панель
// и палитра ставят её в своё содержимое. Окно Radix прячет от диктора всё вокруг себя
// (hideOthers), развёрнутая панель — aria-modal; итог «Роль передана», «Изменения не сохранены»
// должен быть слышен и поверх них. ToastProvider озвучивает новый тост в области верхнего
// открытого слоя, а если слоёв нет — в своей. Без ToastProvider область не нужна.
import { useContext, useLayoutEffect, useRef } from 'react';
import { ToastLayersContext } from './toast-context.ts';

export function ToastLayerRegion({ active = true }: { active?: boolean }) {
  const layers = useContext(ToastLayersContext);
  const politeRef = useRef<HTMLDivElement>(null);
  const assertiveRef = useRef<HTMLDivElement>(null);
  // До эффектов отрисовки: тост, показанный сразу после открытия слоя, уже идёт в его область.
  // Слой закрывается (active — false) раньше, чем уходит со страницы: Radix доигрывает анимацию
  // закрытия. Тост, показанный вместе с закрытием («Роль передана» и закрыть окно), уходит
  // в область ниже, а не пропадает вместе со слоем.
  useLayoutEffect(() => {
    const polite = politeRef.current;
    const assertive = assertiveRef.current;
    if (!active || !layers || !polite || !assertive) return undefined;
    return layers.register({ polite, assertive });
  }, [active, layers]);
  if (!layers) return null;
  // Без role: роль status и alert — у постоянных областей ToastProvider; здесь те же aria-live
  // и aria-atomic, а поиск по роли в окне находит только его собственные сообщения.
  return (
    <>
      <div ref={politeRef} className="kp-sr-only" aria-live="polite" aria-atomic="true" />
      <div ref={assertiveRef} className="kp-sr-only" aria-live="assertive" aria-atomic="true" />
    </>
  );
}
